import { cn } from '@/utils/style';
import WrappedGift from '../../../../public/images/medicine-dictionary/wrappedGift.svg';

interface Props {
  simplifiedName?: string;
  storages?: string[];
}

const MedicineGuideStorage = (props: Props) => {
  return (
    <section className={cn('flex flex-col gap-[20px] px-[24px] py-[28px]')}>
      <div className='flex items-center gap-[8px]'>
        <WrappedGift className='shrink-0' />
        <h2 className={cn('typography-ui-19sb shrink-1 select-text text-gray-700')}>
          {props.simplifiedName} 보관 방법
        </h2>
      </div>
      <ul className='flex flex-col gap-[8px]'>
        {props.storages?.map((storage) => {
          return (
            <li
              className={cn([
                'typography-ui-15r select-text text-gray-700',
                'relative pl-[20px]',
                'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                'flex gap-[8px]',
              ])}
              key={`storage-${storage}`}
            >
              {storage}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default MedicineGuideStorage;
